import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Foods from "../views/Foods.vue";
import FoodDetail from "../views/FoodDetail.vue";
import Pesanan from "../views/Pesanan.vue";
import PesananSukses from "../views/PesananSukses.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/foods",
    name: "Foods",
    component: Foods,
  },
  {
    path: "/foods/:id",
    name: "FoodDetail",
    component: FoodDetail,
  },
  {
    path: "/pesanan",
    name: "Pesanan",
    component: Pesanan
  },
  {
    path: "/pesanan-sukses",
    name: "PesananSukses",
    component: PesananSukses
  }
];

const router = new VueRouter({
  routes,
});

export default router;
